import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import PetProgressbar from '../../../components/v2/progrees-bars/PetProgressBar'
import { useAppSelector } from '../../../store'
import { PetState, setPetCategoryId, setPetFields } from '../../../store/petSlice'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import { Container } from '../../../assets/styles/GlobalStyle'
import Input from '../../../components/v2/Input'
import api from '../../../api'
import Loader from '../../../components/Loader'
import { toast } from 'react-toastify'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { AppState, clearPhoneInfo } from '../../../store/appSlice'
import { Helmet } from 'react-helmet-async'

const ChoosePet = () => {
  //
  const dispatch = useDispatch()
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { filter, screenHeader } = useAppSelector((data: { pet: PetState }) => data.pet)
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetPetPageInfoQuery('pet-dog-or-cat')
  //
  const pageTitle = pageInfo?.translations[lang]?.title
  const stepName = pageInfo?.translations[lang]?.stepName
  //
  const { data: petCategories, isLoading: isPetCategoryLoading } = api.useGetPetCategoriesQuery(undefined)
  //
  //
  const [getLeftCompanies, { data: leftCompanies }] = api.usePetLeftCompaniesMutation()
  //
  useEffect(() => {
    if (filter.petCategoryId) {
      //
      const GetCompaniesFunction = async () => {
        try {
          await getLeftCompanies({
            step: 'zero',
            animalCategoryId: filter?.petCategoryId as number,
          }).unwrap()
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (GetCompaniesFunction) (single)')
          }
        }
      }
      //
      GetCompaniesFunction()
    }

    return () => {}
  }, [getLeftCompanies, filter?.petCategoryId])
  //
  //
  // english letter regex
  const englishLetterRegex = /^[A-Za-z]+$/
  //
  // georgian letter regex
  const georgianLetterRegex = /^[\u10D0-\u10FF]*$/
  //
  const letterRegex = lang === 'ge' ? georgianLetterRegex : englishLetterRegex

  //
  const ValidationSchema = Yup.object({
    name: Yup.string()
      .transform((value) => value.replace(/\s+/g, ''))
      .matches(letterRegex, lang === 'ge' ? `${t('onlyGeorgianLetters')}` : `${t('onlyEnglishLetters')}`)
      .required(`${t('required')}`),
  })
  //y
  //
  const initialValues = {
    name: filter.petInfo.name || '',
  }
  // formi state
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema,
    enableReinitialize: true,
    validateOnMount: true,
    onSubmit: () => {},
  })
  //
  //
  const MainLoading = isPageInfoLoading || isPetCategoryLoading
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Container>
        <Content>
          <Title text={pageTitle} />

          <PetProgressbar stepName={stepName} />

          <Cards>
            {pageInfo?.listItems?.map((item: any, index: number) => {
              return (
                <HorizontalCard
                  className="horizontal-card"
                  key={index}
                  disabled={false}
                  title={item?.translations?.[lang]?.title}
                  imgUrl={item?.image}
                  selected={item?.type === filter.petInfo.pet ? true : false}
                  onClick={() => {
                    const animalCategoryId = petCategories?.find((x) => x.alias === item?.type)?.id
                    //
                    return [
                      dispatch(
                        setPetFields({
                          fieldName: 'name',
                          fieldValue: '',
                        }),
                      ),
                      //
                      dispatch(
                        setPetFields({
                          fieldName: 'pet',
                          fieldValue: item.type,
                        }),
                      ),
                      //
                      dispatch(setPetCategoryId(animalCategoryId as number)),
                    ]
                  }}
                >
                  {filter.petInfo.pet === item?.type ? (
                    <>
                      <hr />

                      <Input
                        id="pet-name"
                        name="pet-name"
                        label={t('petName')}
                        width={'fullWidth'}
                        type="text"
                        value={filter.petInfo.name || ''}
                        onChange={(value) => [
                          dispatch(
                            setPetFields({
                              fieldName: 'name',
                              fieldValue: value,
                            }),
                          ),
                          formik.setFieldValue('name', value),
                        ]}
                        error={formik.errors.name && filter.petInfo.name ? true : false}
                        errorText={formik.errors.name}
                        onBlur={formik.handleBlur}
                      />
                    </>
                  ) : null}
                </HorizontalCard>
              )
            })}
          </Cards>

          <RemainingCompanies
            style={{
              opacity: leftCompanies ? '1' : '0',
              marginInline: 'auto',
            }}
            text={`${t('offerAvailable')}: ${leftCompanies?.companiesCount} `}
          />

          <Buttons>
            <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/category')} />
            <NavigationButton
              text={`${t('next')}`}
              buttonType="next"
              disabled={
                formik.isValid &&
                filter.petInfo.pet &&
                filter.petInfo.name &&
                leftCompanies &&
                leftCompanies?.companiesCount &&
                leftCompanies?.companiesCount > 0
                  ? false
                  : true
              }
              onClick={() => [dispatch(clearPhoneInfo()), navigate('/pet-info')]}
            />
          </Buttons>
        </Content>
      </Container>
      <BackgroundIcon />
    </Wrapper>
  )
}
//
const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Cards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  min-width: 464px;

  .horizontal-card-content {
    align-items: center;
  }

  .horizontal-card {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  ${Responsive.mobile} {
    margin-top: 24px;

    min-width: unset;

    .horizontal-card {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`
const Content = styled.div`
  padding-block: 60px;
  position: relative;
  z-index: 2;

  ${Responsive.mobile} {
    padding-block: 30px;
  }
`
const Wrapper = styled.div`
  /*  */
`
//
export default ChoosePet
